import { useLayoutEffect, useRef } from 'react';
import { useResetScrollPosition } from '@/hooks/useResetScrollPosition';

let sidebarScrollTop = 0;

export function useDesktopProfileScroll(isDesktop: boolean) {
  const sidebarRef = useRef<HTMLElement>(null);

  useResetScrollPosition(isDesktop);

  useLayoutEffect(() => {
    if (!isDesktop) return;

    const sidebar = sidebarRef.current;

    if (!sidebar) return;

    sidebar.scrollTop = sidebarScrollTop;

    return () => {
      sidebarScrollTop = sidebar.scrollTop;
    };
  }, [isDesktop]);

  return { sidebarRef };
}
